
export default function BlogHero() {
  return (
    <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c2f04b60364c85d063bdac9d83a804b6.jpg"
          alt="Blog Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center pt-20">
        <div className="inline-flex items-center gap-2 bg-accent-green/20 border border-accent-green/30 px-4 py-2 rounded-full mb-6">
          <i className="ri-article-line text-accent-green"></i>
          <span className="text-accent-green text-sm font-medium">Blog NeuroAgents</span>
        </div>
        
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Insights sobre{' '}
          <span className="text-accent-green">IA</span> e{' '}
          <span className="text-accent-green">Automação</span>
        </h1>
        
        <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto mb-8">
          Artigos, tutoriais e tendências para transformar seu negócio com inteligência artificial
        </p>

        {/* Search Bar */}
        <div className="max-w-xl mx-auto">
          <div className="relative">
            <input
              type="text"
              placeholder="Buscar artigos..."
              className="w-full bg-white/10 border border-white/20 rounded-full py-4 px-6 pl-14 text-white placeholder-gray-400 focus:outline-none focus:border-accent-green/50 transition-colors"
            />
            <i className="ri-search-line absolute left-5 top-1/2 -translate-y-1/2 text-gray-400 text-xl"></i>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}
